import { Vector2d } from "@stage/math";
export var Vector2ds;
(function (_Vector2ds) {
  function clone(vec) {
    return {
      x: vec.x,
      y: vec.y
    };
  }

  /**
   * 偏移
   * @param a
   * @param b
   */
  function translate(a, b) {
    return Vector2d.add(a, b);
  }
  _Vector2ds.translate = translate;
  function rotate(point, deg) {
    var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      x: 0,
      y: 0
    };
    return Vector2d.rotate(point, deg, origin);
  }
  _Vector2ds.rotate = rotate;
  function scale(vec, scale, origin) {
    return {
      x: (vec.x - origin.x) * scale + origin.x,
      y: (vec.y - origin.y) * scale + origin.y
    };
  }
  _Vector2ds.scale = scale;
})(Vector2ds || (Vector2ds = {}));